export const objectToDisplayText = (value: unknown): string => {
    if (value === null || value === undefined) return "";

    if (typeof value === "string") return value;
    if (typeof value === "number" || typeof value === "boolean") return String(value);

    if (Array.isArray(value)) {
        return value.map((item) => objectToDisplayText(item)).filter(Boolean).join(", ");
    }

    if (typeof value === "object") {
        const objectValue = value as Record<string, unknown>;
        const preferredValue = objectValue.displayName || objectValue.name || objectValue.mail || objectValue.userPrincipalName || objectValue.id;
        if (preferredValue) return objectToDisplayText(preferredValue);

        return Object.entries(objectValue)
            .map(([key, nestedValue]) => {
                const nestedText = objectToDisplayText(nestedValue);
                return nestedText ? `${key}: ${nestedText}` : key;
            })
            .join(", ");
    }

    return String(value);
};
